import { render } from "./C4Data.vue?vue&type=template&id=665adf62"
import script from "./C4Data.vue?vue&type=script&lang=js"
export * from "./C4Data.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__